import { useEffect, useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa"; // tambahin FaTimes
import eventsLocal from "../../data/events";
import apiService from "../../services/api";

function DocumentsTab({ event }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewDoc, setPreviewDoc] = useState(null);

  useEffect(() => {
    if (!event?.id) return;

    async function loadDocuments() {
      try {
        const res = await fetch(
          `${apiService.getBaseUrl()}/documents/event/${event.id}`
        );

        if (!res.ok) throw new Error("Failed to fetch documents");

        const json = await res.json();
        const apiDocs = json.data || [];

        if (apiDocs.length === 0) {
          const offlineEvent = eventsLocal.find(
            (e) => e.id === event.id || e.event_public_id === event.event_public_id
          );
          setDocuments(offlineEvent?.documents || []);
        } else {
          setDocuments(apiDocs);
        }
      } catch (err) {
        console.warn("API gagal → fallback ke offline");
        const offlineEvent = eventsLocal.find(
          (e) => e.id === event.id || e.event_public_id === event.event_public_id
        );
        setDocuments(offlineEvent?.documents || []);
      } finally {
        setLoading(false);
      }
    }

    loadDocuments();
  }, [event]);

  if (loading) {
    return <p className="text-gray-500">Loading documents...</p>;
  }

  if (documents.length === 0) {
    return <p className="text-gray-500 italic">No documents available.</p>;
  }

  return (
    <div>
      <table className="w-full border text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="text-left px-4 py-2 border">Documents</th>
            <th className="text-center px-4 py-2 border w-32">Action</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc) => (
            <tr key={doc.id} className="hover:bg-gray-50">
              <td className="px-4 py-2 border">{doc.document_name}</td>
              <td className="px-4 py-2 border text-center">
                <button
                  onClick={() => setPreviewDoc({ 
                    file_url: apiService.getDocumentById(doc.id)
                  })}
                  className="inline-flex items-center justify-center w-8 h-8 rounded bg-blue-600 hover:bg-blue-700 text-white"
                  title="Preview document"
                >
                  <FaSearch className="text-sm" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* POPUP MODAL */}
      {previewDoc && previewDoc.file_url && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded shadow-lg w-11/12 h-[80vh] flex flex-col">
            <div className="flex justify-between items-center p-4 border-b">
              <span className="font-medium text-sm">{previewDoc.document_name}</span>
              <button
                onClick={() => setPreviewDoc(null)}
                className="text-gray-600 hover:text-red-600"
                title="Close"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>
            <div className="flex-1">
              <iframe
                src={previewDoc.file_url}
                title={previewDoc.document_name}
                className="w-full h-full border-0"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DocumentsTab;
